import { Button, Modal, Space } from 'antd'
import { useExchangeStore } from 'app/hooks/trade/exchangeStore'
import React from 'react'
import { Text, View } from 'styles/reactnative'
import GSlipage from './GSlipage'
import useSWR from 'swr'
import API from 'utils/api'
import { useToken } from 'app/hooks'

// const GSlipageItem = ({group_id, ep_id, ep}) =>{
// 	const {data:token} = useToken()

// 	const key = '/admin/slip/gslip?group_id='+group_id+'&ep_id='+ep_id;
// 	const {data, mutate} = useSWR(key, async (url)=>{
// 		const res = await API.get(key, token+'', {}, false);

// 		console.log(res);
// 	})

// 	return (<View style={{ display: 'flex', flexDirection: 'row', width:'100%', flex:1, borderBottom: `1px solid #cdcdcd` }}>
// 		<Text style={{
// 			width: '100%',
// 			padding: 10,
// 			fontSize: 11,
// 			fontWeight: 'bold',
// 			justifyContent: 'flex-start',
// 			alignItems: 'flex-start',
// 			textAlign: 'left',
// 		}}>[{ep?.groupname} - {ep?.id}] {ep?.pairs}</Text>
// 		<GSlipage group_id={group_id} ep_id={ep?.id} />
// 	</View>)
// }

const GSlipageList = ({ group_id }) => {
	const { data: token } = useToken()

	const [show, setShow] = React.useState<any>(false)

	const { EPs } = useExchangeStore()
	//정렬은 ep?.pairs ABC순으로 정렬
	const showEPs = EPs?.filter(ep => ep?.openstatus < 4)?.sort((a, b) => {
		if (a?.pairs < b?.pairs) return -1
		if (a?.pairs > b?.pairs) return 1
		return 0
	})

	// const key = '/admin/slip/gslip?group_id=' + group_id + '&ep_id=*'
	// const { data, mutate } = useSWR(key, async url => {
	// 	const res = await API.get(key, token + '', {}, false)

	// 	return res?.result?.result || []
	// })

	// console.log("GSLIP", data)

	return (
		<Space
			style={{ width: '100%', padding: 0, fontSize: 11 }}
			size={0}
			direction="horizontal">
			{show && (
				<Modal
					title={'그룹별 설정 / 노출, 슬리피지 : ' + group_id + '번그룹'}
					open={show}
					width={700}
					onCancel={() => setShow(false)}
					footer={null}>
					{showEPs.map((ep, i) => (
						// <GSlipageItem group_id={group_id} ep_id={ep?.id} ep={ep} />
						<View
							style={{
								display: 'flex',
								flexDirection: 'row',
								width: '100%',
								flex: 1,
								borderBottom: `1px solid #cdcdcd`,
							}}>
							<Text
								style={{
									width: '100%',
									padding: 10,
									fontSize: 11,
									fontWeight: 'bold',
									justifyContent: 'flex-start',
									alignItems: 'flex-start',
									textAlign: 'left',
								}}>
								[{ep?.groupname} - {ep?.id}] {ep?.pairs}
							</Text>
							<GSlipage group_id={group_id} ep_id={ep?.id} />
						</View>
					))}
				</Modal>
			)}
			<Button onClick={() => setShow(true)}>수정</Button>
		</Space>
	)
}

export default React.memo(GSlipageList)
